import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getResponsable, getResponsables, newResponsable } from "../../../../redux/actions/empleador";
import { postCabecera } from "../../../../redux/actions/resolucion";
import CircularLoading from "../../../commons/loading/CircularLoading";
import NewContactoDialog from "../../../commons/responsables/dialog/NewContactoDialog";
import ResponsablesEnum from "../../../enums/responsablesEnum";
import { StyledResolucion } from "../../../styled/Prevencion";
import CabeceraForm from "./CabeceraForm";
import Res81ResponsableDatosDialog from "./formulario/responsables/Res81ResponsableDatosDialog";
import Res81ResponsableHySDialog from "./formulario/responsables/Res81ResponsableHySDialog";
import Res81ResponsableMedicinaDialog from "./formulario/responsables/Res81ResponsableMedicinaDialog";

const initialValues = {
  cantidadTrabajadoresProduccion: 0,
  cantidadTrabajadoresEventualesProduccion: 0,
  cantidadTrabajadoresAdministracion: 0,
  cantidadTrabajadoresEventualesAdministracion: 0,
  sePuedeFumar: false,
  espacioParaFumar: false,
  responsableEmpresa: null,
  responsableMedicina: null,
  responsableSH: null,
  contacto: null,
  horasMensualesMedicina: null,
  horasMensualesSH: null,

  // No son parte del form pero los inicializo para evitar errores. Ejemplo al crear uno nuevo tienen que mostrarse el nuevo
  idSector: "",
  idPuesto: ""
};

const CabeceraContainer = ({
  nextForm,
  handleCancelResolucion,
  establecimiento,
}) => {
  const dispatch = useDispatch();
  const cabeceraRedux = useSelector(
    (state) => state.resolucion.postResolucion.cabecera
  );
  const isSubmittingResponsable = useSelector((state) => state.empleador.postResponsables.loading);

  const [openDialogDatos, setOpenDialogDatos] = useState(false);
  const [openDialogMedicina, setOpenDialogMedicina] = useState(false);
  const [openDialogHyS, setOpenDialogHyS] = useState(false);
  const [openDialogContacto, setOpenDialogContacto] = useState(false);

  const [formModel, setFormModel] = useState(null);
  const [respState, setResp] = useState("ResponsableSH");
  const [responsableType, setResponsableType] = useState(null);
  const [isDatosResponsable, setIsDatosResponsable] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [isValidating, setIsValidating] = useState(false);

  // En caso de que el form tenga valores necesitamos que los responsables ya esten cargados, pero no podemos usar el loading de responsables ya que dejaria cargando el form cada vez que se agrega un responsable
  useEffect(() => {
    const responsablePromises = Object.values(ResponsablesEnum).map(enumValue =>
      dispatch(getResponsables(enumValue))
    );
    Promise.all(responsablePromises).finally(() => {
      setInitialLoading(false);
    });
  }, [])


  useEffect(() => {
    if (establecimiento !== null) {
      setFormModel(() => ({
        ...initialValues,
        cantidadTrabajadoresProduccion:
          cabeceraRedux?.cantidadTrabajadoresProduccion ||
          initialValues.cantidadTrabajadoresProduccion,
        cantidadTrabajadoresAdministracion:
          cabeceraRedux?.cantidadTrabajadoresAdministracion ||
          initialValues.cantidadTrabajadoresAdministracion,
        cantidadTrabajadoresEventualesAdministracion:
          cabeceraRedux?.cantidadTrabajadoresEventualesAdministracion ||
          initialValues.cantidadTrabajadoresEventualesAdministracion,
        cantidadTrabajadoresEventualesProduccion:
          cabeceraRedux?.cantidadTrabajadoresEventualesProduccion ||
          initialValues.cantidadTrabajadoresEventualesProduccion,
        sePuedeFumar: cabeceraRedux?.sePuedeFumar || initialValues.sePuedeFumar,
        espacioParaFumar:
          cabeceraRedux?.espacioParaFumar || initialValues.espacioParaFumar,
        responsableEmpresa:
          cabeceraRedux?.responsableEmpresa || initialValues.responsableEmpresa,
        responsableMedicina:
          cabeceraRedux?.responsableMedicina ||
          initialValues.responsableMedicina,
        responsableSH:
          cabeceraRedux?.responsableSH || initialValues.responsableSH,
        contacto: cabeceraRedux?.contacto || initialValues.contacto,
        horasMensualesMedicina: initialValues.horasMensualesMedicina,
        horasMensualesSH: initialValues.horasMensualesSH,
        idEstablecimientoDeclaradoSRT: cabeceraRedux?.idEstablecimientoDeclaradoSRT,
      }));
    }
  }, [establecimiento]);

  const handleSubmit = (values) => {
    setIsValidating(true);

    const checkPromises = [];

    if (values.responsableMedicina) {
      checkPromises.push(dispatch(getResponsable(values.responsableMedicina)));
    } else {
      checkPromises.push(Promise.resolve(null));
    }

    if (values.responsableSH) {
      checkPromises.push(dispatch(getResponsable(values.responsableSH)));
    } else {
      checkPromises.push(Promise.resolve(null));
    }

    if (values.responsableEmpresa) {
      checkPromises.push(dispatch(getResponsable(values.responsableEmpresa)));
    } else {
      checkPromises.push(Promise.resolve(null));
    }

    Promise.all(checkPromises)
      .then(([resMedicina, resSH, resEmpresa]) => {
        let isValid = true;

        if (resMedicina?.value?.data) {
          if (!resMedicina.value.data.cuit || !resMedicina.value.data.nombreCompleto || resMedicina.value.data.propio === null || resMedicina.value.data.propio === undefined) {
            toast.error("El Responsable de Medicina Laboral tiene datos faltantes (CUIT, Nombre o Relación)");
            isValid = false;
          }
          if (!resMedicina.value.data.nroMatricula || !resMedicina.value.data.matriculaOtorgadaPor) {
            toast.error("El Responsable de Medicina Laboral no tiene los datos de matrícula completos");
            isValid = false;
          }
          if (!resMedicina.value.data.horasMensuales || resMedicina.value.data.horasMensuales <= 0) {
            toast.error("El Responsable de Medicina no tiene horas mensuales asignadas");
            isValid = false;
          }
        }

        if (resSH?.value?.data) {
          if (!resSH.value.data.cuit || !resSH.value.data.nombreCompleto || resSH.value.data.propio === null || resSH.value.data.propio === undefined) {
            toast.error("El Responsable de Seguridad e Higiene tiene datos faltantes (CUIT, Nombre o Relación)");
            isValid = false;
          }
          if (!resSH.value.data.nroMatricula || !resSH.value.data.matriculaOtorgadaPor) {
            toast.error("El Responsable de Seguridad e Higiene no tiene los datos de matrícula completos");
            isValid = false;
          }
          if (!resSH.value.data.horasMensuales || resSH.value.data.horasMensuales <= 0) {
            toast.error("El Responsable de Seguridad e Higiene no tiene horas mensuales asignadas");
            isValid = false;
          }
        }

        if (resEmpresa?.value?.data) {
          if (!resEmpresa.value.data.cuit || !resEmpresa.value.data.nombreCompleto || resEmpresa.value.data.propio === null || resEmpresa.value.data.propio === undefined) {
            toast.error("El Responsable de Empresa tiene datos faltantes (CUIT, Nombre o Relación)");
            isValid = false;
          }
          if (!resEmpresa.value.data.representacion) {
            toast.error("El Responsable de Empresa no tiene representación");
            isValid = false;
          }
        }

        if (isValid) {
          dispatch(postCabecera(values));
          nextForm("Sustancias");
        }
      })
      .catch((error) => {
        console.error("Error validando horas de responsables:", error);
        toast.error("Ocurrió un error al validar los responsables");
      })
      .finally(() => {
        setIsValidating(false);
      });
  };

  const handleOpenDialog = (resp, cu, isDatos = false) => {
    setIsEditing(false);
    setEditingData(null);
    setEditingId(null);
    setIsDatosResponsable(isDatos);

    if (cu === ResponsablesEnum.contactoEmpresa) {
      setOpenDialogContacto(true);
      return;
    }
    setResp(resp);
    setResponsableType(cu);

    if (resp === "responsableEmpresa") {
      setOpenDialogDatos(true);
    } else if (resp === "responsableMedicina") {
      setOpenDialogMedicina(true);
    } else if (resp === "responsableSH") {
      setOpenDialogHyS(true);
    }
  };

  const handleEditResponsable = (resp, cu, id, isDatos = false) => {
    setIsEditing(true);
    setEditingId(id);
    setResp(resp);
    setResponsableType(cu);
    setIsDatosResponsable(isDatos);

    // Obtener datos del responsable
    dispatch(getResponsable(id)).then((response) => {
      const data = response.value.data;
      // El backend devuelve idResponsableEmpleador, guardamos ese ID
      setEditingId(data.idResponsableEmpleador);
      setEditingData(data);

      // Abrir el diálogo correspondiente
      if (cu === ResponsablesEnum.contactoEmpresa) {
        setOpenDialogContacto(true);
      } else if (resp === "responsableEmpresa") {
        setOpenDialogDatos(true);
      } else if (resp === "responsableMedicina") {
        setOpenDialogMedicina(true);
      } else if (resp === "responsableSH") {
        setOpenDialogHyS(true);
      }
    }).catch((error) => {
      toast.error("Error al cargar los datos del responsable");
      console.error("Error loading responsable:", error);
    });
  };

  const handleCloseDatosDialog = () => {
    setOpenDialogDatos(false);
    setIsEditing(false);
    setEditingData(null);
    setEditingId(null);
  };

  const handleCloseMedicinaDialog = () => {
    setOpenDialogMedicina(false);
    setIsEditing(false);
    setEditingData(null);
    setEditingId(null);
  };

  const handleCloseHySDialog = () => {
    setOpenDialogHyS(false);
    setIsEditing(false);
    setEditingData(null);
    setEditingId(null);
  };

  const handleCloseContactoDialog = () => {
    setOpenDialogContacto(false);
    setIsEditing(false);
    setEditingData(null);
    setEditingId(null);
  };

  const handleAddContacto = (values) => {
    if (isSubmittingResponsable) {
      return;
    }

    const contactoPayload = {
      apellido: values.apellidoNombre?.split(" ").slice(-1)[0] || "",
      nombres: values.apellidoNombre?.split(" ").slice(0, -1).join(" ") || "",
      cuit: values.cuil,
      telefono: values.telefono,
      email: values.email,
      cargoEmpresa: values.cargoEmpresa,
    };

    // Si estamos editando, agregar el ID
    if (isEditing && editingId) {
      contactoPayload.id = editingId;
    }

    dispatch(newResponsable(contactoPayload)).then(() => {
      dispatch(getResponsables(ResponsablesEnum.contactoEmpresa)).then((res) => {
        const contactoId = isEditing ? editingId : res.value.data[res.value.data.length - 1].id;
        setFormModel({
          ...formModel,
          contacto: contactoId,
        });
        setOpenDialogContacto(false);
        setIsEditing(false);
        setEditingData(null);
        setEditingId(null);
        toast.success(isEditing ? "Contacto actualizado correctamente" : "Contacto agregado correctamente");
      });
    }).catch((error) => {
      toast.error("Error al guardar el contacto");
      console.error("Error saving contacto:", error);
    })
  };

  const handleAddResponsable = (values) => {
    if (isSubmittingResponsable) {
      return;
    }

    // Si estamos editando, agregar el ID al payload
    const payload = isEditing && editingId ? { ...values, id: editingId } : values;

    dispatch(newResponsable(payload)).then((resp) => {
      dispatch(getResponsables(responsableType, isDatosResponsable)).then((res) => {
        const responsableId = isEditing ? editingId : res.value.data[res.value.data.length - 1].id;
        const responsableNombre = isEditing
          ? res.value.data.find(r => r.id === editingId)?.nombre
          : res.value.data[res.value.data.length - 1].nombre;

        let objAux = {
          id: responsableId,
          nombre: responsableNombre,
        };

        if (respState === "responsableEmpresa") {
          setFormModel({
            ...formModel,
            responsableEmpresa: objAux.id,
          });
          setOpenDialogDatos(false);
        } else if (respState === "responsableMedicina") {
          setFormModel({
            ...formModel,
            responsableMedicina: objAux.id,
            horasMensualesMedicina: values?.horasAsignadas ?? null,
          });
          setOpenDialogMedicina(false);
        } else if (respState === "responsableSH") {
          setFormModel({
            ...formModel,
            responsableSH: objAux.id,
            horasMensualesSH: values?.horasAsignadas ?? null,
          });
          setOpenDialogHyS(false);
        } else if (respState === "contacto") {
          setFormModel({
            ...formModel,
            contacto: objAux.id,
          });
        }

        setIsEditing(false);
        setEditingData(null);
        setEditingId(null);
        toast.success(isEditing ? "Responsable actualizado correctamente" : "Responsable agregado correctamente");
      });
    }).catch((error) => {
      toast.error("Error al guardar el responsable");
      console.error("Error saving responsable:", error);
    })
  };

  return (
    <StyledResolucion.FormsContainer>
      {
        initialLoading ?
          (<CircularLoading />)
          : (
            <>
              <CabeceraForm
                handleSubmit={handleSubmit}
                handleCancelForm={handleCancelResolucion}
                handleOpenDialog={handleOpenDialog}
                handleEditResponsable={handleEditResponsable}
                formModel={formModel}
                establecimiento={establecimiento}
                isValidating={isValidating}
              />
              <Res81ResponsableDatosDialog
                open={openDialogDatos}
                handleSubmit={handleAddResponsable}
                handleClose={handleCloseDatosDialog}
                initialValues={isEditing ? editingData : undefined}
                isEditing={isEditing}
                loading={isSubmittingResponsable}
              />
              <Res81ResponsableMedicinaDialog
                open={openDialogMedicina}
                handleSubmit={handleAddResponsable}
                handleClose={handleCloseMedicinaDialog}
                initialValues={isEditing ? editingData : undefined}
                isEditing={isEditing}
                loading={isSubmittingResponsable}
              />
              <Res81ResponsableHySDialog
                open={openDialogHyS}
                handleSubmit={handleAddResponsable}
                handleClose={handleCloseHySDialog}
                initialValues={isEditing ? editingData : undefined}
                isEditing={isEditing}
                loading={isSubmittingResponsable}
              />
              <NewContactoDialog
                open={openDialogContacto}
                handleSubmit={handleAddContacto}
                handleClose={handleCloseContactoDialog}
                initialValues={isEditing ? editingData : undefined}
                isEditing={isEditing}
                loading={isSubmittingResponsable}
              />
            </>

          )
      }

    </StyledResolucion.FormsContainer>
  );
};

export default CabeceraContainer;
